import { useProduct } from "../queries/product";

import SyProductForm from "../widgets/SyProductForm";

export default function UpdateProductPage({ route }) {
    
    const { loading, error, data } = useProduct(route.params.id);

    return <SyProductForm {...data?.product} loading={loading} error={error}></SyProductForm>
}